var version = {
    "name":      "dativery",
    "buildDateCode": "20260612-151841",
    "buildDate": "Fri Jun 12 2026 15:18:41 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260612-151841",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;